let splitApiUrl = 'api.myriad.health';
const apiUrl = process.env.ENV !== 'local' ? process.env.REACT_APP_BASE_API_URL : 'armac.local';

if (process.env.ENV !== 'local' && apiUrl?.includes('://')) {
  splitApiUrl = apiUrl.split('://')[1];
}

if (!splitApiUrl?.includes('api') && process.env.ENV !== 'local') {
  splitApiUrl = 'api.' + splitApiUrl;
}

const secureProtocol = window.location.protocol === 'https:' ? 'wss' : 'ws';
const webSocketApiUrl = `${secureProtocol}://${splitApiUrl}`;

const socketServerUrl = process.env.ENV !== 'local' ? webSocketApiUrl : 'ws://armac.local:8080';

export default socketServerUrl;
